import React, { useRef, useContext, useEffect, useLayoutEffect } from "react";
import moment from "moment";
import TopNav from "../layout/TopNav";
import HeroSectionGuest from "../landingpage/HeroSectionGuest";
import FreeSections from "../landingpage/FreeSections";
import StandardSections from "../landingpage/StandardSections";
import DemoSection from "../landingpage/DemoSection";
import PlansSectionGuest from "../landingpage/PlansSectionGuest";
import Footer from "../layout/Footer";
import HeroSectionFreePeriod from "../landingpage/HeroSectionFreePeriod";
import PlansSectionFreePeriod from "../landingpage/PlansSectionFreePeriod";
import HeroSectionUserPaid from "../landingpage/HeroSectionUserPaid";
import scrollToComponent from "react-scroll-to-component-ssr";
import PlansSectionUserPaid from "../landingpage/PlansSectionUserPaid";
import HeroSectionActivePlan from "../landingpage/HeroSectionActivePlan";
import PlansSectionActivePlan from "../landingpage/PlansSectionActivePlan";
import PlansSectionMemberPaid from "../landingpage/PlansSectionMemberPaid";
import AppContext from "../AppContext";
import { trackPageView } from "../../utils/adobeAnalytics";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';

const LandingPage = ({
  isAuthenticated,
  freeUntil,
  onSubscribe,
  myPlan,
  hasAccess,
  spxPurchase,
  hasAccessUntil,
  gracePeriod,
  isFreePeriod,
  isMember,
  plans,
  plansLoading,
  userPermission,
  userId,
}) => {
  let subStatus = ""
  // Adobe Analytics
  const { isFirstRender, setIsFirstRender } = useContext(AppContext);
  useEffect(() => {
    if (!isFirstRender) {
      trackPageView({ eVar4: "landing page" });
    } else {
      setIsFirstRender(false);
    }

  }, []);
  useEffect(() => {
    if (hasAccess && hasAccess == true) {
      if (isMember == true) {
        subStatus = "subscribed:pmi_membership"
      }
      else {
        subStatus = "subscribed:stdplus_subscription"
      }
    }
    else {
      subStatus = "Non-subscribed"
    }
    if (isAuthenticated) {
      let loginData = {
        event: 'loggedin',
        eventInfo: 'loggedin',

        user: {
          membershipTier: userPermission?.isMember?.membership,
          membershipStatus: userPermission?.isMember?.isMember == true ? 'active' : 'expired',
          pmiID: userId,
          loginStatus: "<logged in status >",
        },
      }
      let subcriptionData = {
        event: "prod-view-load",
        eventInfo: "prod-view-load",
        action: "prod-view",
        cart: {
          product: [{
            productName: "DP002",
            productCat: "Digital Product",
          }]
        }
      }

      let subscriptionStatus = {
        event: "sd-app-load",
        eventInfo: "sd-app-load",
        sd: {
          renewalDate: subStatus === "Non-subscribed" ? "Not available" : hasAccessUntil.split('T')[0],
          subStatus: subStatus,

        }
      }
      pushDatatoAdobeLayer({ loginData, subcriptionData, subscriptionStatus, pageData: false })
    }
  }, []);

  // end adobe Analytics
  const plansSection = useRef(null);
  const userInFreePeriod = isAuthenticated && isFreePeriod;
  const userHasActivePlan =
    isAuthenticated && !isFreePeriod && myPlan && hasAccess;
  const userHasAccessAfterCancellation =
    isAuthenticated && !isFreePeriod && hasAccess;
  const userInPaidPeriod =
    isAuthenticated &&
    !isFreePeriod &&
    !isMember &&
    !userHasAccessAfterCancellation;
  const memberInPaidPeriod =
    isAuthenticated && !isFreePeriod && isMember && !userHasActivePlan;

  const now = moment();
  const endDate = moment(hasAccessUntil);
  const grace = moment(hasAccessUntil).subtract(gracePeriod, "days");

  const isInGracePeriod = endDate.isAfter(now) && grace.isBefore(now);

  const scrollToPlansSection = () => {
    scrollToComponent(plansSection.current, {
      offset: -90,
      align: "top",
    });
  };

  if (plansLoading) return <div />;

  const heroSection = () => {
    if (!isAuthenticated) return <HeroSectionGuest freeUntil={freeUntil} />;
    if (userInFreePeriod) return <HeroSectionFreePeriod />;
    if (userInPaidPeriod || isInGracePeriod)
      return <HeroSectionUserPaid gotoPlans={scrollToPlansSection} spxPurchase={spxPurchase} isMember={isMember} />;
    if (userHasActivePlan || userHasAccessAfterCancellation)
      return <HeroSectionActivePlan />;
    if (memberInPaidPeriod)
      return <HeroSectionUserPaid gotoPlans={scrollToPlansSection} spxPurchase={spxPurchase} isMember={isMember} />;
  };

  const renderPlansSection = () => {
    if (!isAuthenticated) return <PlansSectionGuest freeUntil={freeUntil} />;
    if (userInFreePeriod) return <PlansSectionFreePeriod />;
    if ((userInPaidPeriod || isInGracePeriod) && !spxPurchase)
      return <PlansSectionUserPaid plans={plans} onSubscribe={onSubscribe} />;
    if (userHasActivePlan || userHasAccessAfterCancellation)
      return <PlansSectionActivePlan />;
    if (memberInPaidPeriod)
      return <PlansSectionMemberPaid plans={plans} onSubscribe={onSubscribe} />;
  };

  return (
    <div>
      <TopNav isAuthenticated={isAuthenticated} />

      {/* HERO SECTION */}
      {heroSection()}

      {/* MAIN COMMON SECTION */}
      <div className="container md:px-8 mx-auto">
        <h1 className="text-xl md:text-3xl text-center px-4 md:px-0 my-8">
          Real-Time Access to Real-World Insights
        </h1>
      </div>

      <div className="container mx-auto">
        {isAuthenticated ? <StandardSections /> : <FreeSections />}
      </div>

      <div className="w-full bg-grey-custom mx-auto mt-16 py-12 px-4 md:px-8">
        <DemoSection />

        {/* PLANS SECTION */}
        <div id="plans-section" className="container mx-auto">
          <div ref={plansSection} />

          {renderPlansSection()}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LandingPage;
